import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl =
  process.env.REACT_APP_CATALOG_BACKEND_URL ||
  (process.env.REACT_APP_BACKEND_URL
    ? process.env.REACT_APP_BACKEND_URL.replace(/\/v1\/?$/, "/v2")
    : "http://localhost:3002/v2");

const initialState = {
  isLoading: false,
  error: null,
  choiceGroups: [],
  choiceGroup: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "catalogChoiceGroup",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    startChoiceGroupLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.choiceGroup = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishLoading(state) {
      state.isLoading = false;
      state.error = null;
    },

    getChoiceGroupsSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroups = JSON.parse(JSON.stringify(action.payload.results || action.payload || []));
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
      state.totalPages = action.payload.totalPages || 0;
      state.totalResults = action.payload.totalResults || 0;
    },

    getChoiceGroupSuccess(state, action) {
      state.isLoading = false;
      state.choiceGroup = JSON.parse(JSON.stringify(action.payload.result || action.payload));
    },
  },
});

export default slice.reducer;

export function getCatalogChoiceGroups({ franchiseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/choice-group`, {
        params: {
          franchiseId,
          page,
          limit,
        },
      });

      dispatch(slice.actions.getChoiceGroupsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load choice groups."));
    }
  };
}

export function createCatalogChoiceGroup({ franchiseId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${backendUrl}/franchise/choice-group`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to create choice group.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}

export function getCatalogChoiceGroup({ franchiseId, choiceGroupId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startChoiceGroupLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/choice-group/${choiceGroupId}`, {
        params: { franchiseId },
      });

      dispatch(slice.actions.getChoiceGroupSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load choice group."));
    }
  };
}

export function updateCatalogChoiceGroup({ franchiseId, choiceGroupId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${backendUrl}/franchise/choice-group/${choiceGroupId}`, payload, {
        params: { franchiseId },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to update choice group.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}
